import type { UseQueryOptions } from "@tanstack/react-query";

import { useApiQuery } from "@/hooks/api/use-api-query";
import type { ApiError } from "@/lib/api-client";

type TenantDashboardResponse = {
	numbers: {
		total: number;
		uniquePrefixes: number;
	};
	cdr: {
		enabled: boolean;
		today: {
			calls: number;
			answered: number;
			answerRate: number;
		};
		yesterday: {
			calls: number;
			answered: number;
			answerRate: number;
		};
		deltas: {
			calls: number;
			answerRate: number;
		};
	};
};

export function useTenantDashboardQuery(
	tenantId: string | undefined,
	options?: Omit<
		UseQueryOptions<TenantDashboardResponse, ApiError>,
		"queryKey" | "queryFn"
	>,
) {
	return useApiQuery<TenantDashboardResponse, ApiError>({
		queryKey: ["tenant-dashboard", tenantId],
		path: tenantId ? `/api/organizations/${tenantId}/dashboard` : "",
		queryOptions: {
			enabled: Boolean(tenantId) && (options?.enabled ?? true),
			...options,
		},
	});
}
